
import { useLanguage } from '../contexts/LanguageContext'

function HomePageContent(){
    const { language } = useLanguage()
    
    const headerText = language === 'eng' 
        ? 'My Code Repositories' 
        : 'Мои репозитории кода'
    
    const linkTitles = {
        'eng': {
            'Github': 'My GitHub profile',
            'GitFlic': 'My GitFlic profile',
            'GitVerse': 'My GitVerse profile',
            'CodeBerg': 'My CodeBerg profile',
            'SourceForge': 'My SourceForge profile'
        },
        'rus': {
            'Github': 'Мой профиль на GitHub',
            'GitFlic': 'Мой профиль на GitFlic',
            'GitVerse': 'Мой профиль на GitVerse',
            'CodeBerg': 'Мой профиль на CodeBerg',
            'SourceForge': 'Мой профиль на SourceForge'
        }
    }
    
    return <>
        <h4>{headerText}</h4>
        <p>
            <ul>
                <li>
                    <a 
                        href="https://github.com/artnazarov/" 
                        target="_blank" 
                        rel="noreferrer"
                        title={linkTitles[language]['Github']}
                    >
                        GitHub
                    </a>
                </li>
                <li>
                    <a 
                        href="https://gitflic.ru/user/artnazarov" 
                        target="_blank" 
                        rel="noreferrer"
                        title={linkTitles[language]['GitFlic']}
                    >
                        GitFlic
                    </a>
                </li>
                <li>
                    <a 
                        href="https://gitverse.ru/ArtNazarov" 
                        target="_blank" 
                        rel="noreferrer"
                        title={linkTitles[language]['GitVerse']}
                    >
                        GitVerse
                    </a>
                </li>
                <li>
                    <a 
                        href="https://codeberg.org/ArtNazarov" 
                        target="_blank" 
                        rel="noreferrer"
                        title={linkTitles[language]['CodeBerg']}
                    >
                        CodeBerg
                    </a>
                </li>
                <li>
                    <a 
                        href="https://sourceforge.net/u/artnazarov/profile/" 
                        target="_blank" 
                        rel="noreferrer"
                        title={linkTitles[language]['SourceForge']}
                    >
                        SourceForge
                    </a>
                </li>
            </ul>
        </p>
    </>
}
 
export default HomePageContent